/**
 * Data layer for `igaming-affiliate-level-ngr-ggr-ftd-report`. Thin typed fetch wrappers over /api/v1/igaming-affiliate-level-ngr-ggr-ftd-report.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingAffiliateLevelNgrGgrFtdReportRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingAffiliateLevelNgrGgrFtdReportResponse {
	count: number;
	items: IgamingAffiliateLevelNgrGgrFtdReportRow[];
}

export interface CreateIgamingAffiliateLevelNgrGgrFtdReportBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-affiliate-level-ngr-ggr-ftd-report";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingAffiliateLevelNgrGgrFtdReportResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingAffiliateLevelNgrGgrFtdReportResponse>(res);
}

export async function create(body: CreateIgamingAffiliateLevelNgrGgrFtdReportBody): Promise<IgamingAffiliateLevelNgrGgrFtdReportRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingAffiliateLevelNgrGgrFtdReportRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingAffiliateLevelNgrGgrFtdReportQueryKeys = {
	all: ["igaming-affiliate-level-ngr-ggr-ftd-report"] as const,
	list: () => [...igamingAffiliateLevelNgrGgrFtdReportQueryKeys.all] as const,
	detail: (id: string) => [...igamingAffiliateLevelNgrGgrFtdReportQueryKeys.all, id] as const,
};
